<section class="brand-plp-body" fxFlex="100" fxLayout="column">

  <div *ngIf="isMobileOrTablet" class="brand-plp-body__info-container" id="brand_page_title">
    <div class="brand-plp-body__info-container__title">
      <ng-container *ngTemplateOutlet="productTitle"></ng-container>
    </div>

    <div
      class="brand-plp-body__info-container__count"
      [ngClass]="{ 'color-blueGrey': isNewPLPVariantRestyle && isPLP }"
    >
      <ng-container *ngTemplateOutlet="productCount"></ng-container>
    </div>
  </div>

  <div class="brand-plp-body__main-container" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between">
      <!--  For desktop, not sticky-->
      <div
        *ngIf="!isMobileOrTablet && !(isZeroResult$ | async)"
        class="brand-plp-body__main-container__actions"
        [ngClass]="{ transparentBg: isNewPLPVariantRestyle && isPLP }"
      >
        <div class="brand-plp-body__main-container__actions__toolbar">
          <div class="brand-plp-body__main-container__actions__title">
            <ng-container *ngTemplateOutlet="productTitle"></ng-container>
          </div>
          <div
            class="brand-plp-body__main-container__actions__count"
            [ngClass]="{ 'color-blueGrey': isNewPLPVariantRestyle && isPLP }"
          >
            <ng-container *ngTemplateOutlet="productCount"></ng-container>
          </div>
        </div>
        <app-search-brand-plp-actions
          fxFlex="100"
          [queryParams]="queryParams"
          [isSticky]="isStickyActions"
          (filterOpened)="toggleFilters(true, applicationEventFilterAreaInteractionType.Open)"
        >
        </app-search-brand-plp-actions>
      </div>
    </div>
    <div fxLayout="row" [ngClass]="{ gutter16: isNewPLPVariantRestyle && isPLP && !isMobileOrTablet }">
      <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="20" fxFlex.mm-tablet="0" fxFlex.mm-mobile="0">
        <aside
          class="brand-plp-body__main-container__filters"
          [ngClass]="{
            'brand-plp-body__main-container__filters--opened': isFiltersBarOpened$ | async
          }"
        >
          <app-search-filters
            [queryParams]="queryParams"
            [productsCount]="totalCount"
            [categories]="categories"
            [isFilterOpen]="isFiltersBarOpened$ | async"
            [isZeroResult]="isZeroResult$ | async"
            [isCategoryListFilter]="true"
            [isBrandPLPPage]="true"
            [isDesktop]="!isMobileOrTablet"
            [isMobileOrTablet]="isMobileOrTablet"
            (filtersClosed)="toggleFilters(false, $event)"
          ></app-search-filters>
        </aside>
        <aside
          *ngIf="!isDesktop && specificFilterType && specificFilterType?.type"
          class="brand-plp-body__main-container__filters"
          [ngClass]="{
            'specific-filter': !!specificFilterType && specificFilterType?.type
          }"
        >
          <app-search-filters
            [queryParams]="queryParams"
            [productsCount]="totalCount"
            [categories]="categories"
            [isFilterOpen]="isFiltersBarOpened$ | async"
            [isZeroResult]="isZeroResult$ | async"
            [isCategoryListFilter]="true"
            [isBrandPLPPage]="false"
            [isDesktop]="!isMobileOrTablet"
            [isMobileOrTablet]="isMobileOrTablet"
            [filterType]="specificFilterType"
            (filtersClosed)="toggleFilters(false, $event)"
            (specificFilterClosed)="toggleSpecificFilters($event)"
          ></app-search-filters>
        </aside>
      </div>
      <div
        [fxFlex]="(isZeroResult$ | async) ? 100 : 80"
        fxFlex.mm-tablet="100"
        fxFlex.mm-mobile="100"
        fxLayout="column"
      >
        <div
          *ngIf="isMobileOrTablet && !(isZeroResult$ | async)"
          class="brand-plp-body__main-container__actions"
          [ngClass]="{ 'is-sticky': isStickyActions }"
          fxLayoutAlign="end start"
          appSticky
          [offset]="0"
          [needToRecalculate]="layoutChanged"
          (stickyStatusChanged)="onActionsStickyStatusChange($event)"
        >
          <app-search-brand-plp-actions
            fxFlex="100"
            [queryParams]="queryParams"
            [isSticky]="isStickyActions"
            (filterOpened)="toggleFilters(true, applicationEventFilterAreaInteractionType.Open)"
          >
          </app-search-brand-plp-actions>
        </div>

        <app-category-facets-carousel
          *ngIf="showFilterFacets && isMobileOrTablet"
          [globalFilter]="false"
          [isBrandPLP]="true"
        ></app-category-facets-carousel>
        <app-filter-facets-carousel
          *ngIf="showFilterFacets && (!isDesktop || (isDesktop && hasFilters))"
          [isMobileOrTablet]="isMobileOrTablet"
          [queryParams]="queryParams"
          [isMobile]="isMobile"
          [isTablet]="isTablet"
          [isDesktop]="isDesktop"
          [fromBrandPage]="true"
          (togglePriceFilter)="togglePriceFilter()"
          (toggleCategoryFilter)="toggleCategoryFilter()"
          (toggleAttributeFilter)="toggleAttributeFilter($event)"
        ></app-filter-facets-carousel>

        <app-search-zero-result
          *ngIf="isZeroResult$ | async"
          [queryParams]="queryParams"
          [isMobileOrTablet]="isMobileOrTablet"
        >
        </app-search-zero-result>

        <app-brand-plp-product-list
          *ngIf="products?.length > 0"
          [products]="products"
          [isDesktop]="!isMobileOrTablet"
          [totalCount]="totalCount"
          [queryParams]="queryParams"
          (productVisibilityChange)="onProductVisibility($event)"
        ></app-brand-plp-product-list>
        <app-vat-disclaimer-plps
          *ngIf="
            isVATDisclaimerEnabled &&
            !(isZeroResult$ | async) &&
            !((this.isLoggedIn$ | async) && (this.isB2CUser$ | async))
          "
          [isDesktop]="isDesktop"
        >
        </app-vat-disclaimer-plps>
        <div
          *ngIf="totalCount"
          class="brand-plp-body__paginator"
          [ngClass]="{ 'pagination-nav-bg': isNewPLPVariantRestyle && isPLP }"
          appIsVisible
          [keepMeTracked]="true"
          (isVisible)="onPaginationVisibilityChange($event)"
        >
          <mm-paginator
            [queryParams]="queryParams"
            [totalCount]="totalCount"
            [loadMoreLabel]="'CATALOG.CATALOG_PAGE.PAGINATOR.LOAD_MORE.LABEL' | translate"
            [defaultLimit]="defaultLimit"
            [isBot]="isBot"
            [showLastPage]="false"
            [hideLoadMoreButton]="true"
            [offsetVector]="defaultLimit"
            (paginationChange)="onPageSelected($event)"
          ></mm-paginator>
        </div>

        <!-- Storyblok dynamic component for bottomContent -->
        <div *ngIf="storyBottomContent?.length && isFirstPage">
          <div *ngFor="let blok of storyBottomContent" [appStoryblokEditable]="blok._editable">
            <ndc-dynamic [ndcDynamicComponent]="components[blok.component]" [ndcDynamicInputs]="buildInputs(blok)">
            </ndc-dynamic>
          </div>
        </div>
        <app-newsletter-wrapper [source]="brandPlpSource"></app-newsletter-wrapper>
      </div>
    </div>
  </div>
  <div
    class="brand-plp-body__overlay"
    *ngIf="(isFiltersBarOpened$ | async) || !!specificFilterType"
    (click)="toggleFilters(false, applicationEventFilterAreaInteractionType.Close)"
  ></div>
</section>

<ng-template #productTitle>
  {{ categoryName ? categoryName : ('CATALOG.CATALOG_PAGE.RECOMMENDED_PRODUCT.PRODUCT' | translate) }}
  {{ 'PAGES.PRODUCT.LABEL.BY' | translate }} {{ brandName }}
</ng-template>

<ng-template #productCount>
  {{
    'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.PRODUCTS_COUNT'
      | translate: { count: totalCount > defaultProductsLimit ? '10000+' : totalCount }
  }}
  <div
    *ngIf="(selectedOption$ | async)?.code === bestMatchSortOption"
    class="sort-toggler__info"
    fxLayout="row"
    fxLayoutAlign="center center"
    fxLayoutGap.mm-tablet="6px"
    fxLayoutGap.mm-desktop="6px"
  >
    <app-tooltip
      class="sort__info-icon"
      [position]="tooltipPosition"
      [bulletBackgroundColor]="!isNewPLPVariantRestyle && isPLP ? bulletBackgroundColor : 'transparent'"
      [bulletTextColor]="bulletTextColor"
      [withBorders]="true"
      [fontSize]="10"
      [height]="12"
      [width]="12"
      [bulletIconName]="!isNewPLPVariantRestyle && isPLP ? 'icon_question_mark' : 'icon_question_mark_blue_grey'"
    >
      <span>
        {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SORT_TOGGLER.BEST_MATCH.TOOLTIP' | translate }}
      </span>
    </app-tooltip>
  </div>
</ng-template>
